'use strict';

angular.module('mandaeApp')
  .factory('Financeiro', function Financeiro(FinanceiroResource) {

    return {
      getTotalFaturas: function(query) {
        return FinanceiroResource.getTotalFaturas(query).$promise;
      }
    }

  });
